import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { Form } from "@circle-react-uikit/Form";

export type BoxModelType = "padding" | "margin";
type BoxModelSide = "Top" | "Bottom" | "Left" | "Right";
type VariableType = "camelCase" | "snakeCase" | "custom" | "hyphen";

interface BoxModelInputProps {
  label: string;
  name: string;
  type: BoxModelType;
  variableType?: VariableType;
}

const inputClassName =
  "border-primary bg-primary text-dark group-hover:border-darkest focus:border-darkest w-full appearance-none rounded-lg border py-2 px-4 text-center focus:!outline-none focus:!ring-0 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [appearance:textfield] [-moz-appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none ";

const sides: BoxModelSide[] = ["Top", "Right", "Bottom", "Left"];

const getFieldName = (
  name: string,
  type: BoxModelType,
  side: BoxModelSide,
  variableType: VariableType = "camelCase",
): string => {
  if (variableType === "custom") {
    return name;
  }

  if (variableType === "snakeCase") {
    return `${name}_${type.toLowerCase()}_${side.toLowerCase()}`;
  }

  if (variableType === "hyphen") {
    return `${name}-${type.toLowerCase()}-${side.toLowerCase()}`;
  }

  return `${name}.${type}${side}`;
};

export const BoxModelInput = ({
  name,
  label,
  type,
  variableType = "camelCase",
}: BoxModelInputProps) => (
  <div className="grid grid-cols-4 gap-2">
    {sides.map(side => {
      const fieldName = getFieldName(name, type, side, variableType);
      return (
        <Form.Item
          key={side}
          name={fieldName}
          label={label}
          hideDescription
          hideBorder
          hideLabel
          isFirstChild
        >
          <div className="flex flex-col gap-2">
            <Form.Input
              name={fieldName}
              type="number"
              className={inputClassName}
            />
            <div className="flex flex-col items-center gap-1">
              <Typography.LabelXs color="text-tertiary" weight="medium">
                {t(`builder_ui.prop_type.styles.sides.${side.toLowerCase()}`)}
              </Typography.LabelXs>
            </div>
          </div>
        </Form.Item>
      );
    })}
  </div>
);
